import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { EMRService } from '../EMR.service';
import { SurgicalHistoryModel } from '../HistoryModels/surgicalhistory.model';
import { DatePipe } from '@angular/common';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DashboardService } from 'app/dashboard/dashboard.service';

import { AuthService } from 'app/auth/auth.service';
import { HelplistService } from 'app/helplist.service';
import { Emr_delete_confirmation_boxComponent } from '../emr_delete_confirmation_box/emr_delete_confirmation_box.component';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddNewSurgeryComponent } from '../NewSurgery/add-new-surgery/add-new-surgery.component';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-other-surgery-popup',
  templateUrl: './other-surgery-popup.component.html',
  styleUrls: ['./other-surgery-popup.component.scss']
})
export class OtherSurgeryPopupComponent implements OnInit {
  destroyaddsurgery$: Subject<boolean> = new Subject<boolean>();
  private selectedSugeryArray: any = [];
  private helplistsergery: any = [];
  private eyetype: string;
  private disablesitel: boolean = true;
  private disablesiter: boolean = true;
  private disablesiteb: boolean = true;
  private disablesiten: boolean = false;
  private filterTerm: any;
  private showspinner: boolean = false;
  private catselected = -1;
  private DoctorCtrl: FormControl;
  private filteredDoctorArray: Observable<any[]>;
  private todaysdate = this.authService.getServerDate;
  private displayedColumns: string[] = ['surgerycode', 'surgeryname'];
  dataSource = new MatTableDataSource<SurgicalHistoryModel>();
  private surgenid: any;
  private stype:any;
  applyFilter_grid(filterValue: string) {

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  selectrow(row) {
    //console.log("row id: " + row.sequence)
    this.dashboardService.selectedRowIndex = row.pkSurgeryId;
    this.emrservice.surgeryhistory_added.surgeryName = row.surgeryName;
    this.emrservice.surgeryhistory_added.fkSurgeryCatId = row.fkSurgeryCatId;
    this.emrservice.surgeryhistory_added.shortName = row.shortName;
    this.emrservice.surgeryhistory_added.surgeryCode = row.surgeryCode;
    this.emrservice.surgeryhistory_added.fK_OperationtypeId = row.fK_OperationtypeId;
    this.emrservice.surgeryhistory_added.isActive = row.isActive;
  }

  // filteredOptions_surgeries: Observable<SurgicalHistoryModel[]>;
  // SurgeryControl = new FormControl();

  // surgerydepartments_ds = new MatTableDataSource<SurgeryDepartmentModel>();
  //  surgerycategories_ds = new MatTableDataSource<CategoriesModel>();
  // displayedColumns_surgerydepartments: string[] = ['surgeryDeptName'];
  // displayedColumns_surgerycategories: string[] = ['surgeryCatName'];

  // surgery_ds = new MatTableDataSource<SurgicalHistoryModel>();
  // displayedColumns_surgery: string[] = ['surgeryCode','surgeryName'];
  // surgicalhistory_ds: MatTableDataSource<SurgicalHistoryModel>
  // displayedColumns_surgicalhistory: string[] = ['surgeryname', 'surgerydate', 'surgeonname', 'place', 'eye', 'remarks', 'Action'];

  constructor(private dialog: MatDialog,
    private emrservice: EMRService,
    private datepipe: DatePipe,
    private authService: AuthService,
    private opdvisitService: OpdVisitService,
    private dashboardService: DashboardService, private service: VoiceRecognitionService,
    private helplistservice: HelplistService, private dialogRef: MatDialogRef<OtherSurgeryPopupComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any) {

    dialogRef.disableClose = true;
    this.service.init();
  }

  checkdisable(type2) {
    if (type2 == 1) {
      this.eyetype = 'LE'
      this.disablesitel = false
      this.disablesiter = true;
      this.disablesiteb = true;
      this.disablesiten = true;

    } else if (type2 == 2) {
      this.eyetype = 'RE'
      this.disablesitel = true
      this.disablesiter = false;
      this.disablesiteb = true;
      this.disablesiten = true;
    } else if (type2 == 3) {
      this.eyetype = 'BE'
      this.disablesitel = true
      this.disablesiter = true;
      this.disablesiteb = false;
      this.disablesiten = true;
    } else if (type2 == 4) {
      this.eyetype = 'None'
      this.disablesitel = true
      this.disablesiter = true;
      this.disablesiteb = true;
      this.disablesiten = false;
    }
  }

  ngOnInit() {
    this.selectedSugeryArray = [];
    this.service.Surgerytxt = '';
    this.helplistsergery = [];
    this.helplistsergery = this.helplistservice.surgeryList.filter(item => item.isActive == true);
    // this.dataSource.data = this.helplistservice.surgeryList.slice().filter(item => item.isActive == true);
    //this.surgerydepartments_ds.data = this.helplistservice.surgery_departments;
    // this.surgerycategories_ds.data = this.helplistservice.categories;
    this.eyetype = 'None'
    this.emrservice.surgicalhistory_client = [];
    // this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client.slice());
    this.stype='S';
    this.getDoctorBrach();

    // this.emrservice.surgeryhistory_added.SurgeryDate = null;
    // this.emrservice.surgeryhistory_added.SurgeonName = '';
    // this.emrservice.surgeryhistory_added.place = '';
    // this.emrservice.surgeryhistory_added.remarks = '';
  }
  searchType(event) {
    this.stype = event;
  }
  UpdateRowCode(i) {
    this.dataSource.data[i].isEdit = false;
    this.dataSource.data[i].isActive = true;
  }

  updateMaster(value, i, type) {

    if (this.dashboardService.selectedRowIndex > 0) {
      if (type == 1) {
        var surgerycode = value;
      } else {
        var surgeryName = value;
      }
      let payload1 = {
        "IsActive": this.emrservice.surgeryhistory_added.isActive,
        "PkSurgeryId": this.dashboardService.selectedRowIndex,
        "FkSurgeryCatId": this.emrservice.surgeryhistory_added.fkSurgeryCatId,
        "FK_OperationtypeId": this.emrservice.surgeryhistory_added.fK_OperationtypeId,
        "SurgeryCode": surgerycode ? surgerycode : this.emrservice.surgeryhistory_added.surgeryCode,
        "SurgeryName": surgeryName ? surgeryName : this.emrservice.surgeryhistory_added.surgeryName,
        "ShortName": this.emrservice.surgeryhistory_added.shortName,
        "InternationalName": null,
        "ArabicSurgeryName": null,
        "ArabicSurgeryNameWeb": null,
        "IsEdit": true
      }
      this.emrservice.InsertSurgeryMaster(payload1).pipe(takeUntil(this.destroyaddsurgery$)).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
          this.getSergurydata(0,0);

        }

      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } else {

      this.dashboardService.openSnackBar("Surgery ID Not Found", "OK");
    }
  }
  getSerguryArray: any = [];
  getSergurydata(type,searchtype) {
    this.showspinner = true;
    this.getSerguryArray = [];
    this.helplistservice.surgeryList = [];
    this.emrservice.GetSurgeryAll(type,searchtype).pipe(takeUntil(this.destroyaddsurgery$)).subscribe(x => {
      this.getSerguryArray = x;
      this.helplistservice.surgeryList = this.getSerguryArray;
      this.dataSource.data = this.getSerguryArray.filter(item => item.isActive == true).slice();
      this.showspinner = false;
    }, err => {
      this.showspinner = false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  filtersurgerydata(event){
    if (event.key === 'Enter') {
      event.preventDefault();
      if(event.target.value.length >=3 ){
        this.emrservice.GetSurgeryAll(event.target.value,this.stype).pipe(takeUntil(this.destroyaddsurgery$)).subscribe((item:any)=>{
          this.helplistsergery =item;    
       },err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
       });
      }
    }else{
    const finddata=this.filerdata(this.helplistservice.surgeryList.slice(),event.target.value);
    if(finddata.length >0){
     this.helplistsergery =finddata;
      
    }else{
      this.helplistsergery =[];
      if(event.target.value.length >=3){
     if(event.target.value !=null && event.target.value !=''){
       var pdata= event.target.value
     }else{
        pdata =0;
     }
   this.emrservice.GetSurgeryAll(pdata,this.stype).pipe(takeUntil(this.destroyaddsurgery$)).subscribe((item:any)=>{
    
        this.helplistsergery =item;
         
     },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
     });
    }
    }
  }
   }
   filerdata(items: any[], searchText: string){ 
    if(this.stype=='S'){
      let smallchar=searchText?searchText.toLowerCase():'';
      return items ? items.filter(item => item.surgeryName?.toLowerCase().indexOf(smallchar) === 0):[];
    }else{
      return items ? items.filter(item => item.surgeryName.search(new RegExp(searchText, 'i')) > -1) : [];
    }
   
   
   }
  getallsurgeries() {
    this.getSergurydata(0,0);
    // this.dataSource.data = this.helplistservice.surgeryList.slice();
  }

  removeselection() {
    this.dataSource.data = this.helplistservice.surgeryList.slice();

    this.catselected = -1;
  }


  filtersurgerylist(row) {
    let catid = row.pkSurgeryCatId;
    this.catselected = catid;

    this.dataSource.data = this.helplistservice.surgeryList.slice().filter(s => s.fkSurgeryCatId == catid);

    //console.log("length " + this.dataSource.data.length);
  }




  // addsurgery() {

  //   if (this.emrservice.surgeryhistory_added.surgeryName != undefined && this.emrservice.surgeryhistory_added.eye != undefined) {
  //     if (this.emrservice.surgeryhistory_added.SurgeonName != '' && this.emrservice.surgeryhistory_added.SurgeonName != undefined) {
  //     if(this.emrservice.surgeryhistory_added.SurgeryDate != '' && this.emrservice.surgeryhistory_added.SurgeryDate != undefined){
  //       this.setotherfields();
  //       this.emrservice.surgicalhistory_client.unshift(this.emrservice.surgeryhistory_added);
  //       this.emrservice.surgeryhistory_added = {};
  //       this.surgenid = 0;
  //       this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client.slice());

  //       this.dashboardService.selectedRowIndex = -1;
  //     }else{
  //       this.dashboardService.openSnackBar("Please select Surgery Date", "OK");
  //     }  

  //     } else {
  //       this.dashboardService.openSnackBar("Please select Surgeon Name", "OK");
  //     }

  //   } else {
  //     this.dashboardService.openSnackBar("Please select at least one surgery and eye", "OK");
  //   }

  // }

  closedialog() {
    this.dialogRef.close(0);
  }


  setotherfields() {

    if (this.emrservice.surgeryhistory_added.SurgeryDate != null) {
      this.emrservice.surgeryhistory_added.SurgeryDate =
        this.datepipe.transform(this.emrservice.surgeryhistory_added.SurgeryDate, "MM-dd-yyyy").toString();

    }
    // else {
    //   this.emrservice.surgeryhistory_added.SurgeryDate =
    //     this.datepipe.transform(new Date(), "MM-dd-yyyy").toString();
    // }
    this.emrservice.surgeryhistory_added.pkSurgeryId = this.dashboardService.selectedRowIndex;
    this.emrservice.surgeryhistory_added.pkTranId = 0;
    this.emrservice.surgeryhistory_added.fK_SurgeonId = this.surgenid;

    this.emrservice.surgeryhistory_added.fkRegId = this.opdvisitService.patientdetails.pkRegId;
    this.emrservice.surgeryhistory_added.pkSynchId = null;
    this.emrservice.surgeryhistory_added.fkReg = null;


    // console.log("start date " +  this.emrservice.pasthistory_added.startDate);

  }

  // applyFilter_surgeries(filterValue: string) {
  //  // this.surgery_ds.filter = filterValue.trim().toLowerCase();
  // }

  // applyFilter(filterValue: string) {
  //   this.surgerydepartments_ds.filter = filterValue.trim().toLowerCase();
  // }



  // save_surgeries_to_server() {
  //   this.dashboardService.subscriptions=  this.emrservice.save_surgeries_to_server().subscribe(
  //     data => this.success_surgeries_saved(data), err => this.failed_surgeries_saved(err)
  //   )
  // }
  // success_surgeries_saved(data) {
  //   this.dialog.closeAll();
  //   this.emrservice.surgicalhistory_client = [];
  //   this.dashboardService.openSnackBar("Record saved successfully ", "OK");
  // }
  // failed_surgeries_saved(err) {
  //   console.log("insert surgeries api failed");
  // }
  //get schedule type
  getDoctorBrach() {
    this.dashboardService.getall_doctors().
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(item => item.isExternal == false);
      // this.doctorControll();
    }
    else {
      this.opdvisitService.doctors = data;
      // this.doctorControll();
    }


  }
  failed_doctors(err) {

  }



  AddNewsurgeriespopup(): void {
    const dialogRef = this.dialog.open(AddNewSurgeryComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '55vw',
      height: 'auto',
      width: '100%',
      disableClose: true
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyaddsurgery$)).subscribe(result => {
      if (result != 0) {
        // this.getallsurgeries();
      }

    });
  }

  deActiveSurgery(surgeryid) {

    if (surgeryid > 0) {

      let payload2 = {
        "PkSurgeryId": surgeryid, "IsActive": false, "IsHidden": true, "IsEdit": true
      }
      this.emrservice.InsertSurgeryMaster(payload2).pipe(takeUntil(this.destroyaddsurgery$)).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.dashboardService.openSnackBar("Record De-Active Successfully", "OK");

          this.getSergurydata(0,0);
        }

      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.dashboardService.openSnackBar("Click isActive checkbox", "OK");
    }


  }




  showSurgeryOptions(event: MatCheckboxChange, row: any, i): void {

    if (event.checked == true) {
      this.helplistsergery[i].isEdit = false;
      this.selectedSugeryArray.push({
        ...row,
        'eye': this.eyetype,
      });

    } else {
      this.helplistsergery[i].isEdit = null;
      this.selectedSugeryArray = this.selectedSugeryArray.filter(item => item.pkSurgeryId != row.pkSurgeryId);

    }
    this.stopService(2);
  }
  selectDeleterow(row: any) {
    const index: number = this.selectedSugeryArray.indexOf(row);
    if (index !== -1) {
      const findindex = this.helplistsergery.findIndex(item => item.pkSurgeryId == row.pkSurgeryId);
      this.helplistsergery[findindex].isEdit = null;
      this.selectedSugeryArray.splice(index, 1);
    }
  }
  transferDataMain() {
    if (this.selectedSugeryArray.length > 0) {
      const checkdoctor = this.opdvisitService.doctors.filter(item => item.userId == this.opdvisitService.DoctorIdEmr);
      const SurgeonName = checkdoctor.length >0 ?checkdoctor[0].userName :null
      const selectedSugeryArray = this.selectedSugeryArray.map(obj => ({ ...obj, SurgeonName: SurgeonName }));
      this.dialogRef.close(selectedSugeryArray);
      for (var i = 0; i < this.selectedSugeryArray.length; i++) {
        let itemdata = this.helplistsergery.filter(item => item.pkSurgeryId == this.selectedSugeryArray[i].pkSurgeryId);
        if (itemdata) {

          itemdata[0].isEdit = null;

        }
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Surgery", "OK");
    }
  }

  startService(type) {

    if (type == 1) {
      this.service.Surgerytxt = '';
      this.service.start('Surgery');
    } else {
      this.service.Surgerytext = '';
      this.service.start('Surgery Search');
    }

  }

  stopService(type) {
    // this.searchSurgery = this.service.Surgerytext;
    if (type == 1) {
      this.service.stop('Surgery');
    } else {
      this.service.stop('Surgery Search');
    }
  }
  clearsearchTxt() {
    this.service.Surgerytxt = '';
  }
  ngOnDestroy() {
    this.destroyaddsurgery$.next(true);
    this.destroyaddsurgery$.unsubscribe();
    this.selectedSugeryArray=null;
    this.helplistsergery=null;
    this.eyetype=null;
    this.emrservice.surgicalhistory_client=null;
  
  }
}
